import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PaymentService {

	constructor(private http: HttpClient) {

	}

	API_URL = environment.ApiUrl;
	ApiKey = environment.ApiKey;
	ApiDateTime = environment.ApiDateTime;

	/* Traer todos los planes */
	getAllPlans(token) {
		let headers = new HttpHeaders();

		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.get(`${this.API_URL}plans/list`, {
			headers: headers,
		});
	}

	/* crear sesion temporal para pago Stripe */
	domainAPP = window.location.href.includes('www')
		? environment.domainWWWOnlyAPP
		: environment.domainOnlyAPP;
	createCheckoutSession(token, id_plan, trial_days) {
		const formData = new FormData();
		let headers = new HttpHeaders();

		formData.append("id_plan", id_plan.toString());
		formData.append("trial_period_days", trial_days.toString());
		formData.append("success_url", `${this.domainAPP}/success-payment`);
		formData.append("cancel_url", `${this.domainAPP}/failed-payment`);

		headers = headers.append('Authorization', `Bearer ${token}`);
		//headers = headers.append('Token', token.toString())

		return this.http.post(`${this.API_URL}payments/create-checkout-session`, formData, {
			headers: headers,
		});
	}

	/* crear portal administración plan por usuario */
	createPortalSession(token) {
		const formData = new FormData();
		let headers = new HttpHeaders();

		formData.append("return_url", `${this.domainAPP}/menu/home`);

		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}payments/create-customer-portal-session`, formData, {
			headers: headers,
		});
	}

	editPlan(token, _id, data) {
		const formPlan = new FormData();
		let headers = new HttpHeaders();

		formPlan.append("id_plan", _id);
		//formPlan.append("data", data); //JSON.stringify(form)

		formPlan.append("title", data.title);
		formPlan.append("price", data.rate);
		formPlan.append("monthly_upload", data.monthly_upload);
		formPlan.append("free_days", data.free_days);
		formPlan.append("participant_only", data.participant_only);
		formPlan.append("web_app", data.web_app);
		formPlan.append("own_presentations", data.own_presentations);
		formPlan.append("join_presentations", data.join_presentations);
		formPlan.append("speaker_presentations", data.speaker_presentations);
		formPlan.append("documents_upload", data.documents_upload);
		formPlan.append("view_documents", data.view_documents);

		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}plans/edit`, formPlan, {
			headers: headers,
		});
	}

	createPlan(token, price_id, type, data) {
		const formPlan = new FormData();
		let headers = new HttpHeaders();
		formPlan.append("price_id", price_id);
		formPlan.append("type", type);
		formPlan.append("data", data); //JSON.stringify(form)


		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}create_pricing_plan`, formPlan, {
			headers: headers,
		});
	}


	editStorageUsage(token, _id, storage_use) {
		const formPlan = new FormData();
		let headers = new HttpHeaders();

		formPlan.append("_id", _id);
		formPlan.append("storage", storage_use);


		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}edit_subscription_storage`, formPlan, {
			headers: headers,
		});
	}

	//version en la que se editaba el almacenamiento por periodo
	getSubscriptionUsage(token, id_subscription, timestamp) {
		let headers = new HttpHeaders();

		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.get(
			`${this.API_URL}get_subscription_usage&id_subscription=${id_subscription}&period_start=${timestamp}&period_end=${timestamp}`,
			{
				headers: headers,
			}
		);
	}

	//version en la que se editaba el almacenamiento por periodo
	editSubscriptionUsage(token, _id, monthly_upload) {
		const formPlan = new FormData();
		let headers = new HttpHeaders();

		formPlan.append("_id", _id);
		formPlan.append("monthly_upload", monthly_upload);


		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}edit_subscription_usage`, formPlan, {
			headers: headers,
		});
	}

	createSubscriptionByAdmin(token, user) {
		const formPlan = new FormData();
		let headers = new HttpHeaders();

		formPlan.append("id_user", user._id);
		formPlan.append("id_pricing_plan", user.id_pricing_plan);
		formPlan.append("status", user.status);
		formPlan.append("current_period_start", user.current_period_start);
		formPlan.append("current_period_end", user.current_period_end);
		formPlan.append("storage", "0");


		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}create_subscription`, formPlan, {
			headers: headers,
		});
	}

	dateServer() {
		return this.http.get(`${this.ApiDateTime}`);
	}
}
